module.exports = __webpack_public_path__ + "cc26bcd858de1de28d28af27172382b1.jpg";